import Color from '../Color.mjs'
import superMeta from '../_MODULE/metaModuleNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.LIGHT_ORANGE,
    codeProp: 'amNo',
    mapIdProp: 'anaMapId',
    mapStsCodeProp: 'anaMapStsCode',
    mapTypeCode: 'ANA_MAP',
    name: '分析域',
    ownerIdProp: 'aaId',
    ownerTextProp: 'aaName',
    ownerType: 'AA',
    textProp: 'amName',
    type: 'AM',
}
